import { isValidEmailFormat } from '../email-format';
import type { EmailInputProperties, FormElement } from '../../model/form.types';
import type { FieldDefinition } from '../../model/types';
import { builderDefaultText, singleColumn, stringShapeIssue, validateFormattedText, valueAsText } from './shared';

type EmailInputElement = FormElement & { properties: EmailInputProperties };

export const INVALID_EMAIL_MESSAGE = 'E-mail inválido.';

export const emailInputDefinition: FieldDefinition<EmailInputElement> = {
  kind: 'field',
  type: 'EMAIL_INPUT',
  emptyValue: builderDefaultText,
  control: (element) => ({ kind: 'text', placeholder: element.properties.placeholder, inputType: 'email' }),
  shapeIssue: stringShapeIssue,
  validate: (element, value) => validateFormattedText(element, value, isValidEmailFormat, INVALID_EMAIL_MESSAGE),
  columns: singleColumn,
  cells: (_element, value) => [valueAsText(value)],
  triggerMatches: () => false,
};
